import ImgListUpload from './ImgListUpload.vue'
export default {
  install: function(Vue){
    Vue.component('ImgListUpload',ImgListUpload)
  }
}